<template>
  <div class="accordion" :class="{ 'accordion--open': isOpen }">
    <div class="accordion__titlebar" @click.prevent="isOpen = !isOpen">
      <div class="accordion__title">{{ title }}</div>
      <svg
        class="accordion__close"
        :class="{ 'accordion__close--open': isOpen }"
        width="18"
        height="11"
        viewBox="0 0 18 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.17208 1.02429C1.7579 0.438544 2.70765 0.438607 3.2934 1.02443L9.14688 6.87869L15.0022 1.02428C15.588 0.43854 16.5377 0.438611 17.1235 1.02444C17.7092 1.61027 17.7092 2.56002 17.1233 3.14576L10.2073 10.0607C9.62148 10.6465 8.67174 10.6464 8.086 10.0606L1.17194 3.14561C0.586188 2.55979 0.586251 1.61004 1.17208 1.02429Z"
          fill="#FF8000"
        />
      </svg>
    </div>
    <VueSlideToggle :open="isOpen">
      <div class="accordion__content">
        <slot></slot>
      </div>
    </VueSlideToggle>
  </div>
</template>

<script>
import { VueSlideToggle } from "vue-slide-toggle";

export default {
  name: "Accordion",
  components: {
    VueSlideToggle,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
      isSelected: false,
      hasTopContent: false,
      hasContent: false,
      el: this,
    };
  },
};
</script>


<style lang="scss">
@import "../../scss/base/variables.scss";

.accordion {
  transition: box-shadow 300ms $t-nice;

  &__titlebar {
    padding: 16px 20px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;
    line-height: 24px;
    cursor: pointer;
    transition: background-color 300ms $t-nice;

    &:hover {
      background-color: $brand-light-grey;
    }
  }

  &__title {
    color: #2e384b;
    font-size: 20px;
    font-weight: 500;
    letter-spacing: -0.5px;
    line-height: 1.2;
    transition: color 300ms $t-nice;
    width: calc(100% - 32px);
    position: relative;
    top: 2px;
  }

  &__content {
    padding: 20px 35px 38px;
    color: #2e384b;
    font-size: 18px;
    line-height: 24px;
    p {
      margin-top: 15px;
      &:first-child {
        margin-top: 0;
      }
    }
    a {
      color: $brand-orange;
    }
  }

  &__close {
    width: 22px;
    height: 22px;
    transition: transform 300ms $t-nice;
    margin-top: 0;

    g {
      fill: #de3c4b;
      transition: fill 300ms $t-nice;
    }

    &--open {
      transform: rotate(180deg);
    }
  }
}
</style>
